const DeleteIcon = () => {
    return (
        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.875 3.75H0V2.5H16.25V3.75H14.375V15H13.125V3.75H3.125V16.25H14.375L13.4997 17.5H1.875V3.75ZM11.25 0H5V1.25H11.25V0Z" fill="#111113" />
        </svg>
    )
}

export default DeleteIcon
